import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { PlatformApiService, ResultFilter, Results } from '../../services/platform-api.service';
import { Account, RoleType} from '../../models/AccountModel';
import { BuyNowPromptComponent } from 'src/app/shared/buynow-prompt.component';
import { MatDialog } from '@angular/material/dialog';
import { SessionService } from 'src/app/services/session.service';
import { DataTableComponent } from 'src/app/shared/tile-data-table/tile-data-table.component';
import { ConfirmationComponent } from 'src/app/shared/confirmation.component';

@Component({
  selector: 'app-account-list',
  templateUrl: './account-list.component.html',
  styleUrls: ['./account-list.component.scss']
})
export class AccountListComponent implements OnInit {

  constructor(private _platformApi: PlatformApiService, public _sessionService: SessionService, public dialog: MatDialog) { }

  @Input() parentAccount: Account;
  @Output() stateChange: EventEmitter<any> = new EventEmitter();
  @ViewChild(DataTableComponent, { static: true }) accountDataTable: DataTableComponent;
  RoleType = RoleType;

  accountList: Results;

  ngOnInit() {
    if(!this._sessionService.hasRole(RoleType.ADMIN)) {
      this.accountDataTable.disableAdd = true;
    }
  }

  isSelectable(account) {
    return true;
  }

  isActive(account) {
    return account.isActive;
  }

  selectAccount(item) {
    this.stateChange.emit({ state: 'SELECT', item });
  }

  editAccount(account) {
    this.stateChange.emit({ state: 'SELECT', item: account });
  }

  deleteAccount(account) {
    const pMessage = account.isActive ? 'Are you sure you want to deactivate this company?' : 'Are you sure you want to permanently delete this company?';
    const statusMsg = account.isActive ? 'Deactivating company...' : 'Deleting company...';

    const dialogRef = this.dialog.open(ConfirmationComponent, {
      panelClass: 'flush-dialog',
      data: {
        promptMessage: [pMessage],
        closeLabel: 'No',
        buttons: [{label:'Yes', value:'YES', color:'primary'}],
        height: 'auto'
      }
    });
    dialogRef.afterClosed().subscribe(confirm => {
      if (confirm == 'YES') {
        this.accountDataTable.showProcessing(statusMsg);

        this._platformApi.deleteAccount(account.id).subscribe(
          resp => {
            this.accountDataTable.executeLoadItems();
          }, err => {
            this.accountDataTable.hideProcessing();
            const errMsg = err.error ? err.error.error : 'An error was encountered. The account could not be deleted.';
            const errorRef = this.dialog.open(ConfirmationComponent, {
              panelClass: 'flush-dialog',
              data: {
                promptMessage: [errMsg],
                promptTitle: 'Error',
                closeLabel: 'Ok',
                buttons: [],
                height: 'auto'
              }
            });
          }
        );
      }
    });
  }

  refresh() {
    this.accountDataTable.executeLoadItems();
  }

  loadAccounts(filter = new ResultFilter()) {
    this.accountDataTable.showProcessing();
    let accountListObservable;
    filter.searchData.includeAssessmentTypes = ['NIST'];
    if (this.parentAccount) {
      accountListObservable = this._platformApi.getSubAccounts(this.parentAccount.id, filter);
    } else {
      accountListObservable = this._platformApi.getAllAccounts(filter);
    }
    accountListObservable.subscribe(results => {
      this.accountList = results;
    })
  }

  newAccount(event?) {
    let allowCreate = false;

    if (this._sessionService.isAccountType('SYSTEM')) {
      allowCreate = true;
    } else {
      const numAllowedAccounts = this._sessionService.getFeature('NUM_SUBACCOUNTS');
      if (numAllowedAccounts != undefined && numAllowedAccounts != null) {
        allowCreate = this.accountList.count < numAllowedAccounts;
      } else {
        allowCreate = true;
      }
    }

    if (!allowCreate) {
      const dialogRef = this.dialog.open(BuyNowPromptComponent, {
        panelClass: 'flush-dialog',
        data: { reason: 'FEATUREUNAVAILABLE', message: 'You have reached the company limit for your trial.  You can continue to provide high-value risk assessments for your other customers by upgrading to a paid subscription.' }
      });
    } else {
      this.stateChange.emit({ state: 'CREATE' });
    }
  }
}
